import { gql } from '@apollo/client';

/** Queries */
export const MATCHED_SEGMENTS_QUERY = gql`
  query FindMatchedProjectsSegments($userId: ID!, $filters: [String!]) {
    findMatchedProjectsSegments(userId: $userId, filters: $filters) {
      id
      device
      operatingSystem
      participantsLanguage
      createdAt
      project {
        id
        name
        testType
        status
        sessionDuration
        welcomeTitle
        welcomeContent
        timeZone
        faceRecording
        projectConsentForms {
          id,
          consentForm {
            id,
            name,
            filePath
          }
        }
      }
      surveys(surveyType: "screener") {
        id
        surveyType
        version
        questions {
          id
          label
          randomize
          questionType
          questionOrder
          questionOptions {
            id
            label
            disqualify
            qualify
            order
            optionType
          }
        }
      }
      testers {
        id
        user{
          id
        }
        status
        approved
        removed
        takeLater
        invitedBy
        testSessions {
          id
          status
          expired
          approved
          removed
          bookingStatus
          startAt
          endAt
          timeZone
          meetingUrlTester
        }
        screenerSession {
          id
          surveyId
          screenerSessionAnswers {
            questionId
            questionOptionId
          }
        }
      },
    }
  }
`;

export const ONGOING_STUDIES_QUERY = gql`
  query OngoingProjects($userId: ID!, $filters: [String!]) {
    ongoingStudies(userId: $userId, filters: $filters) {
      id
      device
      operatingSystem
      participantsLanguage
      createdAt
      project {
        id
        name
        testType
        status
        sessionDuration
        welcomeTitle
        welcomeContent
        timeZone
        faceRecording
        projectConsentForms {
          id,
          consentForm {
            id,
            name,
            filePath
          }
        }
      }
      surveys {
        surveyType
        questions {
          id
          label
          questionType
          questionOrder
          questionOptions {
            id
            label
            disqualify
            qualify
            order
            optionType
          }
        }
      }
      testers {
        id
        status
        approved
        removed
        takeLater
        invitedBy
        testSessions {
          id
          status
          expired
          approved
          removed
          bookingStatus
          startAt
          endAt
          meetingUrlTester
          timeZone
        }
        screenerSession {
          id
          surveyId
          screenerSessionAnswers {
            questionId
            questionOptionId
          }
        }
      },
    }
  }
`;

/** Mutations */
export const ANSWER_SCREENER_SURVEY = gql`
  mutation AnswerScreenerSurvey($attributes: [ScreenerSessionAnswerAttributes!]!, $projectId: ID!, $segmentId: ID!, $surveyId: ID!) {
    answerScreenerSurvey(attributes: $attributes, projectId: $projectId, segmentId: $segmentId, surveyId: $surveyId) {
      tester {
        id
        status
        testSessions {
          id
        }
      }
    }
  }
`;

export const REJECT_STUDY = gql`
  mutation RejectStudy($segmentId: ID!, $disqualifiedReason: TesterDisqualifiedReasonEnum!) {
    rejectStudy(segmentId: $segmentId, disqualifiedReason: $disqualifiedReason) {
      tester {
        id
        status
        project{
          disqualifyRedirectUrl
        }
      }
    }
  }
`;

export const CONSENT_FORM_ANSWER_BY_TESTER_ID = gql`
  mutation SaveConsentFormAnswer($status: TesterStatusEnum!, $testerId: ID!) {
    saveConsentFormAnswer(status: $status, testerId: $testerId) {
      tester {
        id
        segment {
          id
        }
        project {
          id
        }
        status
        disqualifiedReason
      }
    }
  }
`;

export const CONSENT_FORM_ANSWER_BY_SEGMENT_AND_PROJECT_ID = gql`
  mutation SaveConsentFormAnswer($status: TesterStatusEnum!, $projectId: ID!, $segmentId: ID!) {
    saveConsentFormAnswer(status: $status, projectId: $projectId, segmentId: $segmentId) {
      tester {
        id
        segment {
          id
        }
        project {
          id
        }
        status
        disqualifiedReason
      }
    }
  }
`;
